import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import ReactOnRails from 'react-on-rails';

import LoginFormApp from './LoginFormAppClient.jsx';

import PreNavigationBanner from '../../Shared/components/shared/preNavigationBannerApp';
import StudentsOnlineNavbarButton from '../../Teacher/startup/StudentsOnlineNavbarButtonLazyClient';

ReactOnRails.register({ LoginFormApp, PreNavigationBanner });

// Rendered by the shared teacher sub-header, so every ReactOnRails bundle must know it
ReactOnRails.register({ StudentsOnlineNavbarButton });
